export default "__VITE_ASSET__Ccdssm9a__"